import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-boy",
  "use": "icon-boy-usage",
  "viewBox": "0 0 27.363 27.124",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27.363 27.124\" id=\"icon-boy\">\n  <path id=\"icon-boy_男\" d=\"M101.167,96.8a1.479,1.479,0,0,0,0,2.957H104.9l-6.89,7A9.786,9.786,0,0,0,92.3,104.93a9.5,9.5,0,1,0,9.7,9.5,9.3,9.3,0,0,0-1.883-5.6l6.881-6.989v3.792a1.479,1.479,0,0,0,2.957,0V96.8Zm-8.86,24.163a6.543,6.543,0,1,1,6.747-6.54A6.653,6.653,0,0,1,92.307,120.963Z\" transform=\"translate(-82.6 -96.8)\" fill=\"#3b86ff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol